import { createInjectionKey as o } from "./highrise529.mjs";
const r = o("n-dialog-provider");
export {
  r as dialogProviderInjectionKey
};
